import useLocale from 'next-translate/useTranslation';

export const CHANNELS_NS = 'agent-channels';

/**
 * Strings of the channel pages. Keys are English sentences, so a key that
 * has no translation yet shows in English, with its placeholders filled in
 * (next-translate would otherwise print the raw `{{name}}`).
 */
export function useChannelsT() {
  const { t, lang } = useLocale(CHANNELS_NS);
  return {
    lang,
    t: (key: string, query?: Record<string, unknown>) =>
      t(key, query, { default: key }),
  };
}
